import { useTranslation } from "react-i18next";
import { IconButton, styled } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { HorizontalRule } from "@mui/icons-material";
import { useChatbotLastUpdatedAt } from "stores";
import { SmallText } from "components";
import ChatbotIcon from "./ChatbotIcon";

const HeaderWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  backgroundColor: theme.navbarColors.background,
  padding: "10px",
  borderRadius: "16px 16px 0 0",
  "& .header": {
    display: "flex",
    gap: "0.75rem",
    alignItems: "flex-start",
    color: "white",
    "& h2.chatbot-title": {
      cursor: "default",
    },
    "& p.update-disclaimer": {
      fontStyle: "italic",
      opacity: 0.8,
      color: "white",
    },
  },
  "& .buttons": {
    color: "white",
    "& .button": {
      color: "white",
      marginLeft: "5px",
      "&:hover": {
        backgroundColor: "#223E45",
      },
    },
  },
}));

const ChatbotHeaderUnstyled = ({ onMinimize, onClose, className }) => {
  const { t } = useTranslation();
  const { lastUpdatedAt } = useChatbotLastUpdatedAt();

  const lastUpdatedText = t("Chatbot.LastUpdatedAt", { date: lastUpdatedAt });

  return (
    <HeaderWrapper className={className}>
      <div className="header">
        <ChatbotIcon fontSize="large" sx={{ color: "#2AC5EC" }} />
        <div>
          <h2 className="chatbot-title">Anna</h2>
          <SmallText className="update-disclaimer">{lastUpdatedText}</SmallText>
        </div>
      </div>
      <div className="buttons">
        <IconButton className="button" size="small" onClick={onMinimize}>
          <HorizontalRule></HorizontalRule>
        </IconButton>
        <IconButton className="button" size="small" onClick={onClose}>
          <CloseIcon></CloseIcon>
        </IconButton>
      </div>
    </HeaderWrapper>
  );
};

const ChatbotHeader = styled(ChatbotHeaderUnstyled)({});

export default ChatbotHeader;
